import React from 'react';
import { QrCode } from 'lucide-react';
import { cn } from '@/shared/utils/cn';
import type { UpiMode } from '../hooks/usePayment';
import { MOBILE_UPI_OPTIONS } from '../utils/constants';
interface UpiPayInfoProps {
  mode: UpiMode;
  onModeChange: (mode: UpiMode) => void;
  onPay?: (mode: UpiMode) => void;
  variant?: 'desktop' | 'mobile';
  disabled?: boolean;
}

export const UpiPayInfo: React.FC<UpiPayInfoProps> = ({
  mode,
  onModeChange,
  onPay,
  variant = 'desktop',
  disabled = false,
}) => {
  if (variant === 'desktop') {
    return (
      <button
        type="button"
        onClick={() => onModeChange('qr')}
        disabled={disabled}
        className={cn(
          'flex w-full items-start gap-4 rounded-md bg-white px-0 py-1 text-left transition-opacity',
          disabled && 'pointer-events-none opacity-60'
        )}
      >
        <span
          className="mt-3 h-[18px] w-[18px] shrink-0 rounded-full border-2 border-[#7C7C7C] bg-white"
          aria-hidden="true"
        />
        <span className="flex min-w-0 flex-1 flex-col">
          <span className="flex items-center gap-4">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#DDF0FF]">
              <QrCode className="h-5 w-5 text-[#011E38]" />
            </span>
            <span className="text-[18px] font-medium leading-none text-[#011E38]">
              QR code
            </span>
          </span>
          <span className="mt-7 block max-w-[690px] text-[15px] font-medium leading-[1.55] tracking-[0.02em] text-[#686868]">
            Scan the QR using any UPI app on your mobile phone like PhonePe, Paytm, GooglePay, BHIM, etc
          </span>
        </span>
      </button>
    );
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-5 gap-2">
        {MOBILE_UPI_OPTIONS.map((option) => {
          const isSelected = mode === option.mode;

          return (
            <button
              key={option.mode}
              type="button"
              onClick={() => {
                onModeChange(option.mode);
                onPay?.(option.mode);
              }}
              disabled={disabled}
              className={cn(
                'flex min-w-0 flex-col items-center gap-3 rounded-md py-1 transition-opacity',
                disabled && 'pointer-events-none opacity-60'
              )}
            >
              <span
                className={cn(
                  'flex h-8 w-8 items-center justify-center rounded-full bg-[#DDF0FF] ring-2 ring-transparent transition-all [&>svg]:scale-75',
                  isSelected && 'ring-[#0B5AC2]'
                )}
              >
                {option.icon}
              </span>
              <span className="min-h-[30px] text-center text-[11px] font-semibold leading-tight text-[#303030]">
                {option.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default UpiPayInfo;
